import { ConfigProvider, theme } from 'antd';
import ScrollTop from 'components/ScrollTop';
import Routes from 'routes';
import './App.css';
import useSocket from 'hooks/useSocket';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { healthCheck } from 'store/slices/settingSlice';

const themeSetting = {
  algorithm: theme.darkAlgorithm,
  token: {
    colorPrimary: '#d48806',
    borderRadius: 2
  }
};

function App() {
  useSocket('connect');
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(healthCheck());
  }, [dispatch]);

  return (
    <ConfigProvider theme={themeSetting}>
      <ScrollTop>
        <Routes />
      </ScrollTop>
    </ConfigProvider>
  );
}

export default App;
